<template>
  <div>
    <v-card outlined >
      <v-card-text>
        <h3>แก้ไขรายการ รายละเอียดสินค้า</h3>

        <v-row>
          <v-divider style="margin: 10px 0"></v-divider>
        </v-row>

        <formInput
          v-bind:idEdit="this.$route.query ? this.$route.query.id : ''"
        />

      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import formInput from '@/views/pages/products/product/form/Form.vue';

export default ({
  components: {
    formInput
  }
});
</script>
<style lang="scss" scoped>

</style>
